import { createContext, useEffect, useState } from "react";
import Cookies from "js-cookie";

const DasboardContext = createContext();

const DashboardProvider = ({ children }) => {
  const [isLogin, setIsLogin] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [profileName, setProfileName] = useState();
  const [bedData, setBedData] = useState([]);
  const [usernames, setUsernames] = useState();
  const [sameSuit, setSameSuit] = useState([]);
  const [filter, setFilter] = useState();

  const [userInfo, setUserInfo] = useState({});

  const [checkedItems, setCheckedItems] = useState([]);

  const getUsernames = async () => {
    try {
      const response = await fetch(`https://app.vivasmartcare.com/api/usernames`);
      setUsernames(await response.json());
    } catch (error) {
      console.error("Error fetching device data:", error);
    }
  };

  const fetchUserInfo = async () => {
    const token = Cookies.get("token");
    if (token !== undefined) {
      try {
        const response = await fetch(`https://app.vivasmartcare.com/api/profile/${token}`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const userInfo = await response.json();
        setUserInfo(userInfo);
        return userInfo;
      } catch (error) {
        console.error("Failed to fetch user info:", error);
        return null;
      }
    }
    return null;
  };

  const getDevices = async () => {
    try {
      const response = await fetch(`https://app.vivasmartcare.com/api/devices`);
      const devices = await response.json();
      const userInfoCompany = await fetchUserInfo();
      let lastDevices;

      if (userInfoCompany?.company !== "all") {
        lastDevices = devices.filter(
          (device) => device.organization === userInfoCompany?.company
        );

        try {
          const deviceResponse = await fetch(
            `https://app.vivasmartcare.com/api/login/${userInfoCompany?.username}`
          );
          const deviceData = await deviceResponse.json();
          lastDevices = lastDevices.filter((device) =>
            deviceData[0].devices.includes(device.deviceID)
          );
        } catch (error) {
          console.error("Error fetching device data:", error);
        }
      } else {
        lastDevices = devices;
      }

      setBedData(lastDevices);

      const groupedData = await lastDevices?.reduce((acc, item) => {
        const { suiteName } = item;
        if (suiteName) {
          if (!acc[suiteName]) {
            acc[suiteName] = [];
          }
          acc[suiteName].push(item);
        }
        return acc;
      }, {});

      setSameSuit(
        Object.keys(groupedData).map((suiteName) => ({
          suiteName,
          items: groupedData[suiteName],
        }))
      );
    } catch (error) {
      console.error("Veri getirilirken bir hata oluştu:", error);
    }
  };

  useEffect(() => {
    getDevices();
  }, []);

  useEffect(() => {
    getUsernames();
  }, [bedData, checkedItems]);

  // For Vital

  return (
    <DasboardContext.Provider
      value={{
        isLogin,
        setIsLogin,
        sidebarOpen,
        setSidebarOpen,
        profileName,
        setProfileName,
        bedData,
        usernames,
        userInfo,
        setUserInfo,
        sameSuit,
        checkedItems,
        setCheckedItems,
        filter,
        setFilter,
      }}
    >
      {children}
    </DasboardContext.Provider>
  );
};

export { DasboardContext, DashboardProvider };
